import React, { useEffect, useState } from 'react';
import Grid from '@material-ui/core/Grid';

const GruposFacebook = () => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [groups, setGroups] = useState([]);

  useEffect(() => {
    // Inicializa o SDK do Facebook
    window.fbAsyncInit = function () {
      window.FB.init({
        appId: '845038597888074',
        cookie: true,
        xfbml: true,
        version: 'v17.0'
      });

      window.FB.getLoginStatus(function (response) {
        if (response.status === 'connected') {
          setIsLoggedIn(true);
          getAllGroups();
        } else {
          setIsLoggedIn(false);
          setGroups([]);
        }
      });
    };

    // Carrega o script do SDK do Facebook
    (function (d, s, id) {
      let js;
      const fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) return;
      js = d.createElement(s);
      js.id = id;
      js.src = 'https://connect.facebook.net/en_US/sdk.js#xfbml=1&version=v13.0&appId=845038597888074&autoLogAppEvents=1';
      fjs.parentNode.insertBefore(js, fjs);
    })(document, 'script', 'facebook-jssdk');

    function getAllGroups() {
      window.FB.api(
        '/me/groups',
        'GET',
        {},
        function (response) {
          console.log('Groups ------------------------------');
          console.log(response);

          if (!response || response.error) {
            console.error('Erro ao buscar grupos:', response.error);
            return;
          }

          const groups_page_1 = response.data || [];
          setGroups(groups_page_1);

          console.log('Página 1:', groups_page_1);
          console.log('Próxima página:', response.paging?.next);

          // Se houver mais páginas, busca todas
          if (response.paging && response.paging.next) {
            fetchNextPage(response.paging.next);
          }
        }
      );
    }

    function fetchNextPage(nextPageURL) {
      fetch(nextPageURL)
        .then((response) => response.json())
        .then((data) => {
          console.log('Próxima Página ------------------------------');
          console.log(data);
          // Adiciona os dados da próxima página
          setGroups((prevGroups) => [...prevGroups, ...(data.data || [])]);

          // Se ainda houver mais páginas, continua buscando
          if (data.paging && data.paging.next) {
            fetchNextPage(data.paging.next);
          }
        })
        .catch((error) => {
          console.log('Erro ao buscar próxima página: ', error);
        });
    }
  }, [isLoggedIn]);

  return (
    <div>
      {isLoggedIn ? (
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <h1>Grupos:</h1>
          </Grid>
          {groups.map((group) => (
            <Grid item xs={12} key={group.id}>
              <div>{group.id + ' - ' + group.name}</div>
              <a
                href={`https://www.facebook.com/groups/${group.id}?sorting_setting=CHRONOLOGICAL`}
                target="_blank"
                rel="noopener noreferrer"
              >
                Click me!
              </a>
            </Grid>
          ))}
        </Grid>
      ) : (
        <div
          className="fb-login-button"
          data-width=""
          data-size="large"
          data-button-type="continue_with"
          data-layout="default"
          data-auto-logout-link="false"
          data-use-continue-as="true"
        ></div>
      )}
    </div>
  );
};

export default GruposFacebook;
